import React from 'react';
import { ArrowRightIcon, LightbulbIcon } from 'lucide-react';
import { BonusSection } from '../components/BonusSection';
import { ChatTestimonials } from '../components/ChatTestimonials';
import { ExpertProfile } from '../components/ExpertProfile';
import { FAQSections } from '../components/FAQSections';
import { FinalCTA } from '../components/FinalCTA';
import { NewFooter } from '../components/NewFooter';
import { ParticipantTestimonials } from '../components/ParticipantTestimonials';
import { RegistrationProvider, useRegistration } from '../components/RegistrationContext';
import { StickyBar } from '../components/StickyBar';
import { TopBanner } from '../components/TopBanner';
import { TransformationSummary } from '../components/TransformationSummary';
import { TrustpilotReviews } from '../components/TrustpilotReviews';
import { WebinarDetailsCard } from '../components/WebinarDetailsCard';
import { WebinarTimeline } from '../components/WebinarTimeline';
import { WhyDifferent } from '../components/WhyDifferent';
function HondentaalFoutenKortContent() {
  const {
    openPopup
  } = useRegistration();
  return <>
      <main className="advertorial-content max-w-3xl mx-auto px-4 pb-28 font-sans text-gray-800" data-id="element-1852" data-mp="h7ibplk746ob">
        <TopBanner data-id="element-1853" data-mp="m51pkkczehfq" />

        <article data-id="element-1854" data-mp="m4ijc0wp1hhj">
          <header className="mb-10 text-center" data-id="element-1855" data-mp="m40ckacenkvd">
            <h1 className="mb-5 text-[1.85rem] font-bold leading-[1.15] text-[rgb(30,64,175)] md:text-4xl" data-id="element-1856" data-mp="qxlc46tncmwo">
              De #1 fout die liefdevolle baasjes maken waardoor hun hond onzeker
              blijft
            </h1>
            <p className="mx-auto max-w-2xl text-base font-medium leading-relaxed text-gray-700 md:text-lg" data-id="element-1857" data-mp="zveyoq1m026n">
              Veel gedrag dat eruitziet als koppigheid of agressie, begint met
              onzekerheid. Dit zijn de vijf fouten die het vaakst terugkomen.
            </p>
          </header>

          <section className="mb-12" data-id="element-1858" data-mp="36pio4us6326e">
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1859" data-mp="3bmitt4l3u2wz">
              <img src="https://cdn.magicpatterns.com/uploads/ao6Guk4iWSDgss2tmjzfxd/1_fout_van_liefdevolle_baasjes_die_honden_onzeker_maakt_(1).jpg" alt="Een hond springt tegen zijn baasje op" className="h-auto w-full" data-id="element-1860" data-mp="3boltyhfz1cff" />
            </figure>
            <p className="mb-4 leading-relaxed" data-id="element-1861" data-mp="38l5y1k7b2q5s">
              Je loopt door het park. Je ziet die andere hond eerder dan je hond
              hem ziet. Riem korter, schouders omhoog, hier gaan we weer. Hij
              verstijft - en voor je het doorhebt sta je te sissen ("Nee. NEE.
              Hier.") en trek je hem mee naar de overkant.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1862" data-mp="4uqcn565qno">Het werkt. Even.</p>
            <p className="mb-4 leading-relaxed" data-id="element-1863" data-mp="3rbdytvnj94it">
              En 's avonds op de bank denk je wat je altijd denkt: hij is zó
              lief. Waarom lukt het bij iedereen behalve bij mij?
            </p>
            <p className="mb-4 text-lg font-semibold leading-relaxed text-gray-900" data-id="element-1864" data-mp="55iff39u7xf9">
              Je hond is niet koppig of agressief. Hij is onzeker - een onzekere
              hond in een stoer lichaam. En gedrag dat "uit het niets" komt?
              Bestaat niet. Er gaat altijd iets aan vooraf; je weet alleen nog
              niet wat.
            </p>
            <p className="leading-relaxed" data-id="element-1865" data-mp="jr5z6nc4ozxl">
              Wij vroegen ruim 1.000 hondeneigenaren naar het gedrag van hun
              hond. Dit zijn de vijf fouten die steeds terugkwamen - bij de
              liefste baasjes die we kennen.
            </p>
          </section>

          <section className="mb-12" aria-labelledby="mistake-five-title" data-id="element-1866" data-mp="9v30jrghjjfe">
            <h2 id="mistake-five-title" className="mb-6 text-2xl font-bold leading-tight text-gray-900 md:text-3xl" data-id="element-1867" data-mp="3s8ix4w3uqsi0">
              Fout #5 - Je zegt wat níét mag, nooit wat wél mag
            </h2>
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1868" data-mp="3n7v82fz6olqf">
              <img src="https://cdn.magicpatterns.com/uploads/4qhZvhbGEiDNkq58ZFo9K5/magnific_a-female-dog-owner-in-her_8vBlxyRIrU.jpg" alt="Een vrouw zit thuis met haar hond, die aandachtig naar haar kijkt" className="h-auto w-full" data-id="element-1869" data-mp="3n9z9mr9m18nj" />
            </figure>
            <p className="leading-relaxed" data-id="element-1870" data-mp="foi2uuuh9rj3">
              Denk aan gisteren. Hoe vaak greep je in omdat iets misging? En hoe
              vaak liet je merken dat iets goed ging? Bij de meeste baasjes: tien
              tegen nul. Zo verzamelt je hond een steeds langere lijst met wat
              verboden is, zonder ooit te horen wat er wél van hem verwacht
              wordt. En dat maakt onzeker, want honden leren niet van falen -
              honden leren van wat goed gaat.
            </p>
          </section>

          <section className="mb-12" aria-labelledby="mistake-four-title" data-id="element-1871" data-mp="1w39uv6npowrv">
            <h2 id="mistake-four-title" className="mb-6 text-2xl font-bold leading-tight text-gray-900 md:text-3xl" data-id="element-1872" data-mp="1r3njl2rg1qlp">
              Fout #4 - Je grijpt in als je hond juist steun zoekt
            </h2>
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1873" data-mp="23l7rwbopife7">
              <img src="https://cdn.magicpatterns.com/uploads/uNjPtxMHwKfohuJH6Gybnv/magnific_closeup-of-a-face-of-a-do_wPSMD267EI.jpg" alt="Een gespannen hond blaft aan de lijn terwijl een kind op de fiets langsrijdt" className="h-auto w-full" data-id="element-1874" data-mp="28cg1p8ty82rw" />
            </figure>
            <p className="leading-relaxed" data-id="element-1875" data-mp="1ko6kylble57m">
              Onweer. De deurbel. Een hond die te snel op jullie afkomt. Het
              emmertje van je hond loopt over - en precies dan komt de correctie.
              Onderzoek van de Universiteit van Porto (2020) laat zien wat dat
              doet: honden die met straf getraind worden, tonen meer stressgedrag
              en hogere cortisolwaarden, ook buiten de training. De plek waar je
              hond zijn spanning kwijt zou moeten - bij jou - wordt zelf een bron
              van spanning. En een gespannen hond vertoont juist méér
              probleemgedrag.
            </p>
          </section>

          <section className="mb-12" aria-labelledby="mistake-three-title" data-id="element-1876" data-mp="1eywxlargfx5g">
            <h2 id="mistake-three-title" className="mb-6 text-2xl font-bold leading-tight text-gray-900 md:text-3xl" data-id="element-1877" data-mp="1ewu60manlvym">
              Fout #3 - Je hond vindt jou onvoorspelbaar
            </h2>
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1878" data-mp="i9p7dpfw4zv7">
              <img src="https://cdn.magicpatterns.com/uploads/jH4KHAx4F82i3waxVcb2FD/magnific_a-male-dog-owner-correcti_YVzQ5zqWeC.jpg" alt="Een man corrigeert zijn hond op de bank terwijl een vrouw toekijkt" className="h-auto w-full" data-id="element-1879" data-mp="w02exqoveck0" />
            </figure>
            <p className="leading-relaxed" data-id="element-1880" data-mp="3voluvu9rirmv">
              Maandag mag hij op de bank, dinsdag niet. Voor jou logisch, voor je
              hond willekeur. Een hond die niet weet wat er komt, blijft
              opletten. Dat is wat baasjes bedoelen met "hij staat altijd aan":
              opkijken bij elke beweging, je volgen van kamer naar kamer, nooit
              echt gaan liggen. Dat is geen aanhankelijkheid. Het is onzekerheid.
            </p>
          </section>

          <section className="mb-12" aria-labelledby="mistake-two-title" data-id="element-1881" data-mp="84zahxzcglxu">
            <h2 id="mistake-two-title" className="mb-6 text-2xl font-bold leading-tight text-gray-900 md:text-3xl" data-id="element-1882" data-mp="82wbwpk4lkhi">
              Fout #2 - Je straft het waarschuwingssignaal weg
            </h2>
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1883" data-mp="35czlv6znhs7">
              <img src="https://cdn.magicpatterns.com/uploads/3SFwU9ksLjjKiCLWWmKPJR/magnific_a-female-dog-owner-being-_BmdLPOcoQR.jpg" alt="Een vrouw houdt een blaffende hond aan de lijn terwijl andere honden voorbijlopen" className="h-auto w-full" data-id="element-1884" data-mp="2ix0iimp639s0" />
            </figure>
            <p className="leading-relaxed" data-id="element-1885" data-mp="20682i78vmhjc">
              Je hond gromt naar een kind. Je schrikt, je corrigeert.
              Begrijpelijk - en schadelijk. Grommen is geen agressie maar
              communicatie: "dit is me te veel." Straf je de grom weg, dan
              verdwijnt het geluid, maar het gevoel blijft. Je krijgt een hond
              die niet meer waarschuwt - die "uit het niets" hapt. In Amerikaans
              onderzoek riepen confronterende technieken zoals de alpha rol bij
              minstens een kwart van de honden een agressieve reactie op.
            </p>
            <aside className="mt-5 rounded-r-lg border-l-4 border-amber-500 bg-amber-50 px-5 py-4 text-sm leading-relaxed text-amber-950" data-id="element-1886" data-mp="2a5gvaws09q44">
              Gromt of hapt je hond regelmatig? Schakel een gedragstherapeut in.
            </aside>
          </section>

          <section className="mb-12 border-t border-gray-200 pt-10" aria-labelledby="mistake-one-title" data-id="element-1887" data-mp="31u0i0wy5me39">
            <h2 id="mistake-one-title" className="mb-6 text-3xl font-bold leading-tight text-[rgb(30,64,175)] md:text-4xl" data-id="element-1888" data-mp="tbigparvgsh8">
              Fout #1 - Je spreekt de taal van je hond niet
            </h2>
            <figure className="mb-6 overflow-hidden rounded-lg bg-slate-100" data-id="element-1889" data-mp="12e9v9jg1o4d3">
              <img src="https://cdn.magicpatterns.com/uploads/tHdZCYJWYGjWNZY8cckFXC/magnific_a-70-year-old-female-dog-_y6JdQLlPW9.jpg" alt="Een vrouw communiceert rustig met haar hond door haar lichaamstaal" className="h-auto w-full" data-id="element-1890" data-mp="17ba0xt8zf53o" />
            </figure>
            <p className="mb-4 leading-relaxed" data-id="element-1891" data-mp="1l2ohzujbww83">
              Wij praten. Honden lezen lichamen. Terwijl jouw stem "rustig maar"
              zegt, zeggen je hoge schouders, je vastzittende adem en je
              knijpende hand iets heel anders. Je hond ziet die andere hond niet
              eens als eerste - hij ziet eerst jóú veranderen.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1892" data-mp="37m79kpogj7as">
              Kijk nu terug naar de vier andere fouten. Het zijn geen vijf losse
              fouten. Het is vijf keer dezelfde fout: jullie spreken allebei een
              taal die de ander niet verstaat. Jouw hond heeft geen handleiding
              nodig - jij hebt zijn woordenboek nodig.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1893" data-mp="3qbna3d056zr7">
              En die wandeling? Je instinct was goed. Afstand nemen is precies
              wat sociaal vaardige honden zelf ook doen. Het enige wat je hond
              niet kon plaatsen, was de sis en de ruk.
            </p>
            <p className="text-lg font-semibold leading-relaxed text-gray-900" data-id="element-1894" data-mp="34tmoxkpq2g4">
              Je hond speelt niet de baas. Jullie begrijpen elkaar alleen niet.
            </p>
          </section>

          <section className="mb-12 rounded-xl bg-blue-50 p-6 md:p-8" aria-labelledby="next-step-title" data-id="element-1895" data-mp="250dgga6vkcab">
            <div className="mb-5 flex items-center gap-3" data-id="element-1896" data-mp="1snjiffio0vyq">
              <LightbulbIcon className="h-7 w-7 flex-none text-blue-700" aria-hidden="true" data-id="element-1897" data-mp="1slymblgpd4yr" />
              <h2 id="next-step-title" className="text-2xl font-bold text-blue-950" data-id="element-1898" data-mp="1jnwpli404yha">
                Dus wat nu?
              </h2>
            </div>
            <p className="mb-4 leading-relaxed" data-id="element-1899" data-mp="2be181b87bbfv">
              Niemand van ons is geboren met kennis van hondentaal. Dat je het
              niet wist, is logisch. Maar wie beter weet, kan beter doen.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1900" data-mp="22ct9qt5oqals">
              En die taal is te leren. Sneller dan je denkt: de belangrijkste
              signalen kun je in één korte training leren herkennen.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1901" data-mp="qxwjjfxrlfcu">
              Daarom geven wij deze week een gratis online webinar over
              communiceren met je hond. Daarin laten we je precies zien wat je
              hond je nú al vertelt - de stille signalen die aan elk geblaf,
              elke grom en elk “uit het niets” voorafgaan - en hoe je met je
              lichaam antwoordt op een manier die hij wél verstaat.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-1902" data-mp="nimmdt3i9tbc">
              Eerlijk is eerlijk: één webinar lost niet elk probleem op. Maar het
              is voor elk liefdevol hondenbaasje de eerste stap - want je kunt
              geen enkel gedrag veranderen bij een hond die je niet verstaat.
            </p>
            <p className="mb-6 font-semibold leading-relaxed text-blue-950" data-id="element-1903" data-mp="3vuqvhavnbci4">
              Je hond geeft iedere dag honderden signalen af en kijkt continu
              naar je lichaamstaal in de hoop te begrijpen wat je hem wilt
              vertellen.
            </p>
            <button type="button" onClick={openPopup} className="flex w-full items-center justify-center gap-2 rounded-lg bg-[#22c55e] px-6 py-4 text-lg font-bold text-white shadow-lg transition-colors hover:bg-[#16a34a] focus:outline-none focus:ring-4 focus:ring-green-200" aria-label="Meld je aan voor het gratis webinar over communiceren met je hond" data-id="element-1904" data-mp="3rugmrqggy7zk">
              Ja, ik wil mijn hond leren verstaan
              <ArrowRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1905" data-mp="3r70xm7nqrup8" />
            </button>
          </section>

          <section className="mb-12" data-id="element-1906" data-mp="3m86gda5fae78">
            <p className="text-lg font-medium leading-relaxed text-gray-900" data-id="element-1907" data-mp="3m751eulad7k8">
              De volgende keer dat je die andere hond aan ziet komen op het pad,
              wil je weten wat je moet doen. Dat begint hier.
            </p>
          </section>
        </article>

        <ParticipantTestimonials data-id="element-1908" data-mp="dtfpkzwogz4i" />
        <ExpertProfile data-id="element-1909" data-mp="8u3007ef9dy8" />
        <WebinarTimeline data-id="element-1910" data-mp="8uuoyzdikdfj" />
        <WebinarDetailsCard data-id="element-1911" data-mp="8vnxa4s4fazs" />
        <BonusSection data-id="element-1912" data-mp="8s8fgu72bnuo" />
        <TrustpilotReviews data-id="element-1913" data-mp="23ajpctsrawal" />
        <WhyDifferent data-id="element-1914" data-mp="2398fqdcmqubk" />
        <FAQSections data-id="element-1915" data-mp="23a1hezwqetmu" />
        <TransformationSummary data-id="element-1916" data-mp="238gvtzseal14" />
        <FinalCTA data-id="element-1917" data-mp="288l4x4qz4dhb" />
        <ChatTestimonials data-id="element-1918" data-mp="2883b0ersabck" />
        <NewFooter data-id="element-1919" data-mp="287a0r3tm93po" />
      </main>
      <StickyBar data-id="element-1920" data-mp="2d0cylo5fezbo" />
    </>;
}
export function HondentaalFoutenKortPage() {
  return <RegistrationProvider data-id="element-1921" data-mp="2h1oozvw4jokx">
      <HondentaalFoutenKortContent data-id="element-1922" data-mp="2h1y58rrdahdf" />
    </RegistrationProvider>;
}